export default class GalleryController {
  constructor() {
    this.currentIndex = 0
    this.totalImages = 0
    this.lightboxOpen = false
    this.lightboxIndex = 0
    this.lightbox = null
    this.lightboxImage = null
    this.lightboxCounter = null
  }

  selectImage(index, fullSrc) {
    const mainImage = this.mainImageTarget
    if (!mainImage || !fullSrc) return

    mainImage.src = fullSrc
    if (this.blurImageTarget) {
      this.blurImageTarget.src = fullSrc
    }
    this.currentIndex = index

    this.element.querySelectorAll('.gallery__thumb').forEach((thumb, i) => {
      thumb.classList.toggle('gallery__thumb--active', i === index)
    })

    this.updateArrows()
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.totalImages
    this.goToIndex(nextIndex)
  }

  prev() {
    const prevIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages
    this.goToIndex(prevIndex)
  }

  goToIndex(index) {
    const thumbs = this.element.querySelectorAll('.gallery__thumb')
    if (index < 0 || index >= thumbs.length) return

    const thumb = thumbs[index]
    const fullSrc = thumb.getAttribute('data-gallery-full-src')
    this.selectImage(index, fullSrc)
  }

  updateArrows() {
    // Arrows always visible for infinite carousel
  }

  handleKeydown(e) {
    if (this.lightboxOpen) {
      if (e.key === 'Escape') {
        e.preventDefault()
        this.closeLightbox()
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault()
        this.lightboxPrev()
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        this.lightboxNext()
      }
      return
    }

    // Arrow keys only work inside lightbox, not on the main page
  }

  // --- Lightbox ---

  initLightbox() {
    this.lightbox = document.createElement('div')
    this.lightbox.className = 'gallery-lightbox'
    this.lightbox.innerHTML = `
      <button class="gallery-lightbox__close" aria-label="Cerrar">&times;</button>
      <button class="gallery-lightbox__nav gallery-lightbox__nav--prev" aria-label="Anterior">
        <svg width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z" clip-rule="evenodd"/>
        </svg>
      </button>
      <img class="gallery-lightbox__image" src="" alt="" />
      <button class="gallery-lightbox__nav gallery-lightbox__nav--next" aria-label="Siguiente">
        <svg width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd"/>
        </svg>
      </button>
      <div class="gallery-lightbox__counter"></div>
    `
    document.body.appendChild(this.lightbox)

    this.lightboxImage = this.lightbox.querySelector('.gallery-lightbox__image')
    this.lightboxCounter = this.lightbox.querySelector('.gallery-lightbox__counter')

    // Close button
    this.lightbox.querySelector('.gallery-lightbox__close').addEventListener('click', () => {
      this.closeLightbox()
    })

    // Backdrop click closes (but not clicks on image or nav)
    this.lightbox.addEventListener('click', (e) => {
      if (e.target === this.lightbox) {
        this.closeLightbox()
      }
    })

    // Nav buttons
    this.lightbox.querySelector('.gallery-lightbox__nav--prev').addEventListener('click', () => {
      this.lightboxPrev()
    })
    this.lightbox.querySelector('.gallery-lightbox__nav--next').addEventListener('click', () => {
      this.lightboxNext()
    })

    // Image click should not close
    this.lightboxImage.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    // Hero/cover image click opens lightbox
    const heroImg = this.element.querySelector('.gallery-grid__hero-img') || this.element.querySelector('.fb-cover__img')
    if (heroImg) {
      heroImg.style.cursor = 'pointer'
      heroImg.addEventListener('click', () => {
        this.openLightbox(this.currentIndex)
      })
    }

    // Grid thumb clicks open lightbox
    this.element.querySelectorAll('.gallery-grid__thumb').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const index = parseInt(btn.getAttribute('data-gallery-index-param'), 10)
        this.openLightbox(index)
      })
    })

    // Photos grid (Fotos tab) clicks open lightbox — elements outside gallery scope
    document.querySelectorAll('.fb-photos-grid__item').forEach(item => {
      item.addEventListener('click', () => {
        const index = parseInt(item.getAttribute('data-gallery-index'), 10)
        this.openLightbox(index)
      })
    })
  }

  openLightbox(index) {
    this.lightboxOpen = true
    this.lightboxIndex = index
    this.lightbox.classList.add('gallery-lightbox--open')
    document.body.style.overflow = 'hidden'
    this.updateLightboxImage()
  }

  closeLightbox() {
    this.lightboxOpen = false
    this.lightbox.classList.remove('gallery-lightbox--open')
    document.body.style.overflow = ''
  }

  lightboxNext() {
    this.lightboxIndex = (this.lightboxIndex + 1) % this.totalImages
    this.updateLightboxImage()
  }

  lightboxPrev() {
    this.lightboxIndex = (this.lightboxIndex - 1 + this.totalImages) % this.totalImages
    this.updateLightboxImage()
  }

  updateLightboxImage() {
    const thumbs = this.element.querySelectorAll('.gallery__thumb')
    if (this.lightboxIndex < 0 || this.lightboxIndex >= thumbs.length) return

    const thumb = thumbs[this.lightboxIndex]
    const fullSrc = thumb.getAttribute('data-gallery-full-src')
    this.lightboxImage.src = fullSrc
    this.lightboxCounter.textContent = `${this.lightboxIndex + 1} / ${this.totalImages}`
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="gallery"]').forEach(el => {
    const controller = new GalleryController()
    controller.element = el
    controller.mainImageTarget = el.querySelector('[data-gallery-target="mainImage"]')
    controller.blurImageTarget = el.querySelector('[data-gallery-target="blurImage"]')

    const thumbs = el.querySelectorAll('.gallery__thumb')
    controller.totalImages = thumbs.length

    // Thumb click handlers (hidden navigation thumbs)
    thumbs.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const index = parseInt(btn.getAttribute('data-gallery-index-param'), 10)
        const fullSrc = btn.getAttribute('data-gallery-full-src')
        controller.selectImage(index, fullSrc)
      })
    })

    // Grid thumb click handlers (visible thumbnail grid)
    el.querySelectorAll('.gallery-grid__thumb').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const index = parseInt(btn.getAttribute('data-gallery-index-param'), 10)
        const fullSrc = btn.getAttribute('data-gallery-full-src')
        controller.selectImage(index, fullSrc)
      })
    })

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      controller.handleKeydown(e)
    })

    // Initialize lightbox
    controller.initLightbox()

    // Initialize arrow visibility
    controller.updateArrows()

    // Extract dominant color from hero image for gradient background
    const heroImg = el.querySelector('.gallery-grid__hero-img')
    const galleryWrap = el.closest('.auction-detail__gallery-wrap')
    if (heroImg && galleryWrap) {
      const applyGradient = () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = 1
          canvas.height = 1
          const ctx = canvas.getContext('2d')
          // Sample from top-left area of the image
          ctx.drawImage(heroImg, 0, 0, heroImg.naturalWidth * 0.3, heroImg.naturalHeight * 0.3, 0, 0, 1, 1)
          const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data
          galleryWrap.style.background = `linear-gradient(to bottom, rgb(${r}, ${g}, ${b}) 0%, #FFFFFF 60%)`
        } catch (e) {
          // CORS or other error — fall back to neutral gradient
          galleryWrap.style.background = 'linear-gradient(to bottom, #65676B 0%, #FFFFFF 60%)'
        }
      }
      if (heroImg.complete && heroImg.naturalWidth > 0) {
        applyGradient()
      } else {
        heroImg.addEventListener('load', applyGradient, { once: true })
      }
    }
  })
})
